import React from 'react';
import PropTypes from 'prop-types';
import { Link, graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { Card } from './Card';
import { theme, media } from '../theme';
import { vr } from '../utils';

const cardWidthLandscapeM = `calc(50% - ${vr(0.5)})`;
const cardWidthDesktopM = 562;
const cardHeightDesktopM = cardWidthDesktopM / 2;

const newsQuery = graphql`
  query NewsPosts{
    news: allMdx(
      sort: {
        fields: [frontmatter___date],
        order: DESC
      },
      filter: {
        frontmatter: {
          templateKey: {eq: "news-post"}, 
          featuredPost: {eq: true}
        }
      },
      limit: 2
    ) {
      edges {
        post: node {
          ...newsPostData
        }
      }
    }

    categories: allFile(filter: {extension: {eq: "md"}, relativeDirectory: {regex: "/nyheder/"}}) {
      group(field: childMdx___frontmatter___cats___value, limit: 2) {
        nodes {
          post: childMdx {
            ...newsPostData
          }
        }
        fieldValue
      }
    }
  }

  fragment newsPostData on Mdx {
    id
    fields {
      slug
    }
    frontmatter {
      date(formatString: "Do MMMM YYYY", locale: "da")
      title
      featuredImage
    }
  }
`;

const placeholderNews = [
  {
    post: {
      id: 'placeholder-1',
      fields: {
        slug: '',
      },
      frontmatter: {
        date: '1. januar 2020',
        title: 'Eksempel på nyhed',
        featuredImage: 'DSC_1514.JPG',
      },
    },
  },
  {
    post: {
      id: 'placeholder-2',
      fields: {
        slug: '',
      },
      frontmatter: {
        date: '1. januar 2020',
        title: 'Andet eksempel',
        featuredImage: 'DSC_1514.JPG',
      },
    },
  },
];

export const NewsRoll = ({ category, isPreviewMode }) => {

  // Use placeholder data if isPreviewMode
  let posts = placeholderNews;

  if (!isPreviewMode) {
    const data = useStaticQuery(newsQuery);

    const news = data.news.edges;

    const categories = data.categories.group.reduce((accumulator, { fieldValue, nodes }) => ({ ...accumulator, [fieldValue]: nodes }), {});

    const shouldShowSpecificCategory = category.length > 0 && Object.keys(categories).includes(category);

    posts = shouldShowSpecificCategory ? categories[category] : news;
  }

  return (
    <>

      <h2>
        <Link to="/nyheder" title="Læs de seneste nyheder fra Søllerød Golfklub">Nyheder</Link>
      </h2>
      <Section>
        {posts.map(({ post }) => {
          const { frontmatter, fields } = post;

          return (
            <Card
              key={post.id}
              title={frontmatter.title}
              date={frontmatter.date}
              image={frontmatter.featuredImage}
              link={fields.slug}
              applyCloudinary
              breakpoints={[
                { width: 375, height: 187 },
                { width: 410, height: 205 },
                { width: 720, height: 360 },
                { width: cardWidthDesktopM, height: cardHeightDesktopM },
                { width: cardWidthDesktopM * 2, height: cardHeightDesktopM * 2 },
                { width: 840 * 2, height: 432 * 2 },
              ]}
              sizes={`
                ${media.landscapeM} ${cardWidthLandscapeM},
                ${media.desktopM} ${cardWidthDesktopM}px,
                calc(100vw - ${theme.containerPadding * 2}px)
              `}
            />
          );
        })}
      </Section>

    </>
  );
};

const Section = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: ${vr(0.5)};
  min-height: auto;
  max-width: 100%;

  > div {
    width: 100%;
    margin-bottom: ${vr(1)};
  }

  @media ${media.landscapeM} {
    flex-direction: row;

    > div {
      width: 48%;
      width: ${cardWidthLandscapeM};
      /* width: 31%;
      width: calc(33% - ${vr(0.5)}); */
      margin-bottom: 0;
    }
  }
`;

NewsRoll.propTypes = {
  category: PropTypes.string,
  isPreviewMode: PropTypes.bool,
};

NewsRoll.defaultProps = {
  category: '',
  isPreviewMode: false,
};
